<template>
  <div class="detail-row-wrapper">

    <div class="category-wrapper">

      <div class="shape-wrapper">

        <div v-for="(image, index) in editableImages"
             class="img-wrapper" :key="index">

          <layout-image-selector v-model="editableImages[index]"
                                 :index="`detail_image_${rowIndex}_${index}`"
                                 :on-image-out-of-size="onImageOutOfSize"/>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import LayoutImageSelector from '@/spa/components/LayoutImageSelector';

export default {
  name: 'LayoutDetailImages',
  components: {
    LayoutImageSelector,
  },
  props: {
    value: Array,
    rowIndex: Number,
    onImageOutOfSize: Function,
  },
  watch: {
    editableImages(value) {
      this.$emit('input', value);
    },

    value(value) {
      this.editableImages = value;
    },
  },
  data() {
    return {
      editableImages: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.detail-row-wrapper {
  display: flex;
  justify-content: left;
  align-items: center;
  align-content: center;
  flex-direction: row;

  .detail-row-header {
    width: 200px;
  }

  .category-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-direction: column;

    .shape-wrapper {
      width: 600px;

      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      flex-direction: row;
      flex-flow: wrap;

      .img-wrapper {
        width: 250px;
        height: 250px;

        border: rgba(0, 0, 0, 0.1) solid 1px;
        border-radius: 5px;

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/wine/details/detail-row/LayoutDetailImages.vue